import { httpClient } from "@adapters/api/HttpClient";

export const scheduledServices = {
  refreshAll: async () => {
    return httpClient.get("/v1/refresh");
  },
};
